import avatarModule from '../avatarModule';

function percentage($filter) {
  'ngInject';

  return function(input, decimals) {
    return $filter('number')(input * 100, decimals);
  };
}

avatarModule.filter('percentage', percentage);

export default percentage;
